/* eslint-disable @typescript-eslint/no-explicit-any */
import { useMutation } from '@tanstack/react-query';
import { apiClient } from '@lib/api-client';
import { queryClient } from '@lib/react-query';
import { notifications } from '@mantine/notifications';
import useStore from '@store/index';
import { uuid } from '@utils/functions';
import { useTranslation } from 'react-i18next';

export const importproduction = (
	data: any
): Promise<{
	response: any;
}> => {
	return apiClient.post('/imports/productions', data);
};

export const useImportProduction = (
	page: number,
	size: number
) => {
	const { setProductionsImportErrors } = useStore();
	const { t } = useTranslation();
	const {
		mutate,
		isPending: isLoading,
		isSuccess,
	} = useMutation({
		mutationFn: importproduction,
		onSuccess: async () => {
			notifications.show({
				title: t('global.success'),
				message: t(
					'productions.notifications.productionSuccessfullyAdded'
				),
				color: 'success',
			});
			queryClient.invalidateQueries({
				queryKey: [
					'productions',
					{ page: page, size: size },
				],
			});
		},
		onError: (error: any) => {
			const formattedErrors = Array.isArray(error?.data)
				? error.data.flatMap(
						({ line, errors }: any) =>
							errors.map((messageError: any) => ({
								message:
									messageError.column +
									' ' +
									messageError.error,
								line,
								id: uuid(),
							}))
						// eslint-disable-next-line no-mixed-spaces-and-tabs
					)
				: [];

			setProductionsImportErrors({
				...error,
				data: formattedErrors,
			});
		},
	});

	return { mutate, isLoading, isSuccess };
};
